/**
 * Custom Map Icons
 * Category-specific icons with animations
 */

import L from 'leaflet';
import { MARKER_CATEGORIES } from './markers.js';

// Category colors
const MARKER_COLOR = '#F06140';

export const CATEGORY_COLORS = {
    [MARKER_CATEGORIES.SCULPTURE]: MARKER_COLOR,
    [MARKER_CATEGORIES.BUILDING]: MARKER_COLOR,
    [MARKER_CATEGORIES.GARDEN]: MARKER_COLOR,
    [MARKER_CATEGORIES.EVENT_SPACE]: MARKER_COLOR,
    [MARKER_CATEGORIES.LANDMARK]: MARKER_COLOR
};

// Category symbols
export const CATEGORY_SYMBOLS = {
    [MARKER_CATEGORIES.SCULPTURE]: '★',
    [MARKER_CATEGORIES.BUILDING]: '★',
    [MARKER_CATEGORIES.GARDEN]: '★',
    [MARKER_CATEGORIES.EVENT_SPACE]: '★',
    [MARKER_CATEGORIES.LANDMARK]: '★'
};

/**
 * Create a custom icon for a category
 * @param {string} category - Marker category
 * @returns {L.DivIcon} Leaflet div icon
 */
export function createCategoryIcon(category) {
    const color = CATEGORY_COLORS[category] || '#666';
    const symbol = CATEGORY_SYMBOLS[category] || '●';

    return L.divIcon({
        html: `
            <div class="custom-marker" style="background-color: ${color};">
                <span class="marker-symbol">${symbol}</span>
                <div class="marker-pulse" style="border-color: ${color};"></div>
            </div>
        `,
        className: 'custom-marker-wrapper',
        iconSize: [20, 20],
        iconAnchor: [10, 10],
        popupAnchor: [0, -10]
    });
}

/**
 * Create icons for all categories
 * @returns {Object} Icons keyed by category
 */
export function createAllCategoryIcons() {
    const icons = {};

    Object.values(MARKER_CATEGORIES).forEach(category => {
        icons[category] = createCategoryIcon(category);
    });

    return icons;
}

export default { createCategoryIcon, createAllCategoryIcons, CATEGORY_COLORS, CATEGORY_SYMBOLS };
